<template>
<div class="chapter">
<div class="inner_page">
<p class="p3"><span class="sz"><b></b> </span></p>
<p class="p3"><span class="sz"><b></b> </span></p>
<p class="p4"><span class="sz">“No one is so generous as he who has nothing to give.”</span></p>
<p class="p5"><span class="sz"> </span></p>
<p class="p6"><span class="sz">FRENCH PROVERB</span></p>
<p class="p3"><span class="sz"> </span></p>
<p class="p3"><span class="sz"> </span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section3.vue?02fd0661